const prefix = 'nzr';

const carbonConfig = {
  accordion: {
    selectorInit: '[data-accordion]',
    selectorAccordionItem: '[data-accordion-item]',
    selectorAccordionContent: '.nzr--accordion__content',
    classActive: 'nzr--accordion__item--active',
    selectorAccordionItemHeading: '[data-accordion-trigger]'
  },
  dropdown: {
    selectorInit: '[data-dropdown]',
    selectorTrigger: `button.${prefix}--dropdown-text`,
    selectorMenu: `.${prefix}--dropdown-list`,
    selectorText: `.${prefix}--dropdown-text`,
    selectorTextInner: `.${prefix}--dropdown-text__inner`,
    selectorItem: `.${prefix}--dropdown-link`,
    selectorItemSelected: `.${prefix}--dropdown--selected`,
    selectorItemFocused: `.${prefix}--dropdown--focused`,
    selectorItemHidden: `[hidden],[aria-hidden="true"]`,
    selectorLinkSelected: `.${prefix}--dropdown--selected .${prefix}--dropdown-link`,
    classShowSelected: `${prefix}--dropdown--show-selected`,
    classSelected: `${prefix}--dropdown--selected`,
    classFocused: `${prefix}--dropdown--focused`,
    classOpen: `${prefix}--dropdown--open`,
    classDisabled: `${prefix}--dropdown--disabled`,
    eventBeforeSelected: 'dropdown-beingselected',
    eventAfterSelected: 'dropdown-selected'
  }
};

module.exports = carbonConfig;
